const Projects = () => {
	return <>
		Project
	</>;
};

export default Projects;
